import Countries from 'pages/ga/countries/Index';
import CountryForm from 'pages/ga/countries/Form';

const CountriesRoutes = [
    { index: true, element: <Countries /> },
    { path: 'add', element: <CountryForm mode="add" /> },
    { path: 'edit/:id', element: <CountryForm mode="edit" /> },
];

export default CountriesRoutes;
